<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card :loading="cargando">
          <v-card-title>
            <v-icon left class="mr-2">mdi-file-plus</v-icon>
            Nuevo Certificado de Incentivo al Retiro
          </v-card-title>

          <v-card-text>
            <v-form ref="form">
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    value="Se generará automáticamente"
                    label="Número de Certificado"
                    outlined
                    readonly
                    hint="El número se asignará al crear el certificado"
                    persistent-hint
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <v-autocomplete
                    v-if="$auth.can(['gestor-subdere-incentivo-retiro'])"
                    v-model="certificado.municipalidad_id"
                    :items="municipalidades"
                    item-text="nombre"
                    item-value="id"
                    label="Municipalidad *"
                    outlined
                    :rules="[v => !!v || 'La municipalidad es requerida']"
                    :loading="cargandoMunicipalidades"
                  />
                </v-col>
                <v-col cols="12">
                  <v-select
                    v-model="certificado.tipo"
                    :items="tiposLey"
                    item-text="nombre"
                    item-value="valor"
                    label="Tipo de Ley *"
                    outlined
                    :rules="[v => !!v || 'El tipo de ley es requerido']"
                    hint="Seleccione el tipo de ley que aplica a este certificado. Para menores de 75 años debe ir a la plataforma de <a href='https://capturarrhh.sinim.gov.cl/login/index.php' target='_blank' rel='noopener'>SINIM</a>"
                    persistent-hint
                  >
                    <template #message="{ message }">
                      <span v-html="message"></span>
                    </template>
                    <template #item="{ item }">
                      <div class="py-2">
                        <div class="font-weight-bold">{{ item.nombre }}</div>
                        <div class="text-caption grey--text">{{ item.descripcion }}</div>
                      </div>
                    </template>
                  </v-select>
                </v-col>
                <v-col cols="12" v-if="esProcesoMayor75">
                  <v-select
                    v-model="certificado.tramo"
                    :items="tramos"
                    item-text="nombre"
                    item-value="valor"
                    label="Tramo *"
                    outlined
                    :rules="[v => !!v || 'El tramo es requerido']"
                    hint="Seleccione el tramo que aplica a este certificado"
                    persistent-hint
                  >
                    <template #item="{ item }">
                      <div class="py-2">
                        <div class="font-weight-bold">{{ item.nombre }}</div>
                        <div class="text-caption grey--text">{{ item.descripcion }}</div>
                      </div>
                    </template>
                  </v-select>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    v-model="certificado.observaciones"
                    label="Observaciones"
                    outlined
                    rows="3"
                    hint="Observaciones generales del certificado"
                  />
                </v-col>
              </v-row>

              <v-alert type="info" text>
                <div class="font-weight-bold mb-2">Pasos para crear el certificado:</div>
                <ol class="ml-4">
                  <li>Complete los datos del certificado (municipalidad y tipo de ley)</li>
                  <li>Guarde el certificado</li>
                  <li>En la siguiente pantalla podrá agregar las postulaciones</li>
                </ol>
              </v-alert>
            </v-form>
          </v-card-text>

          <v-card-actions>
            <v-btn text @click="cancelar">
              <v-icon left>mdi-close</v-icon>
              Cancelar
            </v-btn>
            <v-spacer />
            <v-btn
              color="primary"
              :loading="guardando"
              @click="crearCertificado"
            >
              <v-icon left>mdi-content-save</v-icon>
              Crear Certificado
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { apiClient } from '@/admin/services/API'
import { notificar, notificarErrorResponse } from '@/admin/utils/notificar'

export default {
  name: 'IncentivosRetiroCertificadoForm',
  data() {
    return {
      cargando: false,
      guardando: false,
      cargandoMunicipalidades: false,
      certificado: {
        municipalidad_id: null,
        tipo: 'ley_21135',
        observaciones: '',
        tramo: null,
      },
      esProcesoMayor75: false,
      municipalidades: [],
      tiposLey: [
        // {
        //   valor: 'ley_21135',
        //   nombre: 'Ley 21.135',
        //   descripcion: 'Proceso Regular (Hombres 65 años, Mujeres 60 años)',
        // },
        // {
        //   valor: 'ley_21724_menor_75',
        //   nombre: 'Ley 21.724 - Menor de 75 años',
        //   descripcion: 'Artículo 88 - Postulantes de 66 años hasta antes de cumplir 75 años',
        // },
        {
          valor: 'ley_21724_mayor_75',
          nombre: 'Ley 21.724 - Mayor de 75 años',
          descripcion: 'Artículo 88 - Postulantes que cumplen 75 años o más (asignación inmediata)',
        },
      ],
      tramos: [
        {
          valor: 1,
          nombre: 'Tramo 1',
          descripcion: 'Postulantes que cuenten con 75 o más años de edad acreditados al 31 de julio de 2026'
        },
        {
          valor: 2,
          nombre: 'Tramo 2',
          descripcion: 'Postulantes que cuenten con 75 o más años de edad entre 01 de agosto al 31 de diciembre de 2026'
        },
      ],
    }
  },
  mounted() {
    this.cargarMunicipalidades()
  },
  watch: {
    'certificado.tipo'(nuevoValor) {
      if (nuevoValor && nuevoValor !== 'ley_21724_mayor_75') {
        this.certificado.tramo = null
        this.esProcesoMayor75 = false
      } else if (nuevoValor === 'ley_21724_mayor_75') {
        this.certificado.tramo = 1
        this.esProcesoMayor75 = true
      }
    },
  },
  methods: {
    async cargarMunicipalidades() {
      try {
        this.cargandoMunicipalidades = true
        const { data } = await apiClient.get('usuarios/instituciones', { params: { tipo: 2 } })
        this.municipalidades = data.data || []
      } catch (error) {
        console.error('Error al cargar municipalidades:', error)
        // Usar municipalidades de prueba si falla
        this.municipalidades = [
          { id: 69255600, nombre: 'Vitacura' },
          { id: 69220900, nombre: 'Santiago' },
        ]
      } finally {
        this.cargandoMunicipalidades = false
      }
    },
    async crearCertificado() {
      // Validar campos requeridos
      if (!this.$refs.form.validate()) {
        notificar({ message: 'Por favor complete todos los campos requeridos', severity: 'error' })
        return
      }

      if (!this.$auth.can(['gestor-subdere-incentivo-retiro'])) {
        this.certificado.municipalidad_id = this.$auth.user().institucion.municipalidad_id ?? this.$auth.user().institucion_id
      }

      if (!this.certificado.municipalidad_id) {
        notificar({ message: 'Debe seleccionar una municipalidad', severity: 'error' })
        return
      }

      if (!this.certificado.tipo) {
        notificar({ message: 'Debe seleccionar el tipo de ley', severity: 'error' })
        return
      }

      try {
        this.guardando = true
        
        const payload = {
          municipalidad_id: this.certificado.municipalidad_id,
          tipo: this.certificado.tipo,
          observaciones: this.certificado.observaciones || '',
          tramo: this.certificado.tramo || null,
        }

        const { data } = await apiClient.post('/tramites/incentivos-retiro/certificados', payload)
        notificar({ message: 'Certificado creado correctamente', severity: 'success' })
        
        // Redirigir al detalle donde se podrán agregar postulaciones
        this.$router.push({ 
          name: 'incentivos-retiro-certificado-detalle', 
          params: { id: data.data.id }
        })
      } catch (error) {
        notificarErrorResponse(error, 'Error al crear el certificado')
      } finally {
        this.guardando = false
      }
    },
    cancelar() {
      if (confirm('¿Está seguro que desea cancelar? Se perderán los cambios no guardados.')) {
        this.$router.push({ name: 'incentivos-retiro-certificados' })
      }
    },
  },
}
</script>

<style scoped>
::v-deep .v-select__selection {
  max-width: 100%;
}
</style>
